import { put, takeEvery } from "redux-saga/effects";

import {
  getMyBetsStart,
  getMyBetsSuccess,
  getMyBetsFailure,
  getBetListStart,
  getBetListSuccess,
  getBetListFailure,
  getCashoutAmountStart,
  getCashoutAmountSuccess,
  getCashoutAmountFailure,
  getCashOutStart,
  getCashOutSuccess,
  getCashOutFailure,
  getSportStatisticsStart,
  getSportStatisticsSuccess,
  getSportStatisticsFailure
} from "../../redux/mybets";
import {
  showErrorMessage,
  showSuccessMessage
} from "../../../redux-saga/redux/toast";
import MyBetsService from "../../services/mybets";

function* myBetsWatcher() {
  yield takeEvery(getMyBetsStart.type, myBetsWorker);
  yield takeEvery(getBetListStart.type, betListWorker);
  yield takeEvery(getCashoutAmountStart.type, cashoutAmountWorker);
  yield takeEvery(getCashOutStart.type, cashOutWorker);
  yield takeEvery(getSportStatisticsStart.type, sportStatisticstWorker);
}

function* myBetsWorker(action) {
  try {
    const { data, error } = yield MyBetsService.getMyBets(action.payload);
    if (data) {
      yield put(getMyBetsSuccess(data));
    }
    if (error) {
      yield put(showErrorMessage({ msg: error }));
      yield put(getMyBetsFailure());
    }
  } catch (error) {
    yield put(getMyBetsFailure());
    yield put(showErrorMessage({ msg: error }));
  }
}

function* betListWorker(action) {
  try {
    const { data, error } = yield MyBetsService.betList(action.payload);
    if (data) {
      yield put(getBetListSuccess(data));
    }
    if (error) {
      yield put(showErrorMessage({ msg: error }));
      yield put(getBetListFailure());
    }
  } catch (error) {
    yield put(getBetListFailure());
    yield put(showErrorMessage({ msg: error }));
  }
}
function* cashoutAmountWorker(action) {
  try {
    const { data, error } = yield MyBetsService.cashoutAmount(action.payload);
    if (data) {
      yield put(getCashoutAmountSuccess(data));
    }
    if (error) {
      yield put(showErrorMessage({ msg: error }));
      yield put(getCashoutAmountFailure());
    }
  } catch (error) {
    yield put(getCashoutAmountFailure());
    yield put(showErrorMessage({ msg: error }));
  }
}

function* cashOutWorker(action) {
  try {
    const { data, error } = yield MyBetsService.cashOut(action.payload);
    if (data) {
      if (data?.cashOut) {
        yield put(showSuccessMessage({ tKey: "MYBETS.CASHOUT_SUCCESSFULLY" }));
      } else {
        yield put(
          showErrorMessage({ tKey: "MYBETS.CASHOUT_AMOUNT_HAS_BEEN_CHANGED" })
        );
      }
      yield put(getCashOutSuccess(data));
    }
    if (error) {
      yield put(showErrorMessage({ msg: error }));
      yield put(getCashOutFailure());
    }
  } catch (error) {
    yield put(getCashOutFailure());
    yield put(showErrorMessage({ msg: error }));
  }
}

function* sportStatisticstWorker(action) {
  try {
    const { data, error } = yield MyBetsService.sportStatistics(action.payload);
    if (data) {
      yield put(getSportStatisticsSuccess(data));
    }
    if (error) {
      yield put(showErrorMessage({ msg: error }));
      yield put(getSportStatisticsFailure());
    }
  } catch (error) {
    yield put(getSportStatisticsFailure());
    yield put(showErrorMessage({ msg: error }));
  }
}

export default myBetsWatcher;
